/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, EventEmitter, Output, Input, ViewContainerRef, ViewChild, ElementRef, Inject, Optional, OnDestroy, HostListener, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormArray, ValidatorFn, AbstractControl } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { RestService } from '../../../../shared/rest.service';
import { Observable } from 'rxjs/Observable';
import { TransportsService } from '../../service/transportsMockUp.service';
import * as moment from 'moment';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { AddressesService } from '../../service/addresses.service';
import { UserService } from '../../../../pages/com.usblick.common/auth/user.service';
import { of, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ItineraryService } from 'app/shared/itinerary.service';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MESSAGE_LOOKUP } from 'model/transport-product.interface';
import { setting } from '../../../../../../setting';
import CssFilterConverter from "css-filter-converter";
import { filter, takeUntil } from 'rxjs/operators';
import { NotFoundModalComponent } from 'app/shared/modals/not-found-modal/not-found-modal.component';
import { NotificationService } from 'app/shared/notifications/notification.service';



@Component({
  selector: 'usb-transports',
  templateUrl: './transports.component.html',
  styleUrls: ['./transports.component.scss'],
  providers: [TransportsService, DatePipe, AddressesService, UpperCasePipe]
})
export class TransportsComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() _close: boolean;
  @Output() origin = new EventEmitter<any>();
  @Output() modal = new EventEmitter<string>();
  @Output() payload = new EventEmitter<any>();
  @Output() results = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<boolean>();

  @ViewChild('auto') auto: MatAutocomplete;
  @ViewChild("originInput") originInput!: ElementRef;
  @ViewChild("destination") myInputField: ElementRef;
  @ViewChild('autocompleteInput') autocompleteInput!: ElementRef;
  @ViewChild('iconInfo') iconInfo!: ElementRef;
  @ViewChild('triggerButton') triggerButton: ElementRef;
    @ViewChild('cardSelectorRoom') cardSelectorRoom: ElementRef;
    @ViewChild('sliderElement') sliderElement!: ElementRef;
    @ViewChild('sliderDestinationElement') sliderDestinationElement!: ElementRef;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  };
  destineValue: boolean;
  destineVale: boolean;
  originValue: boolean;
  selectediataCodeDestiny: any;
  selectediataCodeOrigin: any;
  iataCodeOrigin: any;
  nameOrigin: any;
  iataCodeDestiny: any;
  nameDestination: any;
  isLoadingResult: boolean;
  _resultsQuery: any;
  _findData: boolean;
  _form: FormGroup;
  minDate: Date;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  _maxPersons: any;
  isCollapsed = false;
  ismeridian = false;
  dest: any;
  ori: any;
  pickup: any;
  dropoff: any;
  passengers: string;
  isOpen= false;

  // Máximo de adultos permitidos en el selector de pasajeros del traslado.
  // Centralizado para que HTML y TS apunten al mismo límite.
  readonly MAX_ADULTS = 55;
  _actualItinerary: any;
  departureDateIn: any;
  arrivalDateIn: any;
  departureDateOut: any;
  airportIn: any;
  idFlight: any;
  itinerary: any;
  message = [];
  colorTextSearch: string;
  destinationOptions :Observable<any[]> = of([]);
  destinationOptions_: Observable<any[]> = of([]);
  now = new Date();
  get currentTime(): string {
    return new Date().toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }
  private _previousTimeValues: { firstTime?: string; secondTime?: string } = {};

/**
 * Returns true if the given date is today in the user's local timezone.
 */
private isToday(date: Date | string | null | undefined): boolean {
  if (!date) return false;
  const d = date instanceof Date ? date : new Date(date);
  const today = new Date();
  return d.getFullYear() === today.getFullYear()
    && d.getMonth() === today.getMonth()
    && d.getDate() === today.getDate();
}

/**
 * Returns the minimum allowed HH:mm for a given control, or null if no
 * restriction applies (e.g. the trip is scheduled for another day).
 * For 'firstTime' the restriction depends on firstArrivalDate.
 * For 'secondTime' the restriction depends on secondArrivalDate.
 */
private getMinAllowedTime(controlName: 'firstTime' | 'secondTime'): string | null {
  const dateField = controlName === 'firstTime' ? 'firstArrivalDate' : 'secondArrivalDate';
  const dateValue = this._form.get(dateField)?.value;
  return this.isToday(dateValue) ? this.currentTime : null;
}

/**
 * Compare two HH:mm strings. Returns true if candidate is earlier than min.
 */
private isTimeBefore(candidate: string, min: string): boolean {
  const toMinutes = (t: string): number => {
    const [h, m] = t.split(':').map(n => parseInt(n, 10));
    return h * 60 + (isNaN(m) ? 0 : m);
  };
  return toMinutes(candidate) < toMinutes(min);
}

/**
 * For 'secondTime': returns the floor time (HH:mm) the user must beat, which is
 * the pickup time when pickup and dropoff happen on the same day.
 * Returns null when no restriction applies (different days, no return date,
 * or firstTime unset).
 */
private getSecondTimeFloor(): string | null {
  const firstArrivalDate = this._form.get('firstArrivalDate')?.value;
  const secondArrivalDate = this._form.get('secondArrivalDate')?.value;
  const firstTime = this._form.get('firstTime')?.value;
  if (!firstTime || !secondArrivalDate) return null;
  if (!this.isSameDay(firstArrivalDate, secondArrivalDate)) return null;
  return firstTime as string;
}

private isSameDay(a: Date | string | null | undefined, b: Date | string | null | undefined): boolean {
  if (!a || !b) return false;
  const da = a instanceof Date ? a : new Date(a);
  const db = b instanceof Date ? b : new Date(b);
  return da.getFullYear() === db.getFullYear()
    && da.getMonth() === db.getMonth()
    && da.getDate() === db.getDate();
}

/**
 * True when the wheel picker for secondTime should clamp to firstTime.
 * Applies only when pickup and dropoff are the same calendar day and a
 * pickup time is set. Exposed publicly so the template can bind [minTime].
 */
isSecondTimeFloorActive(): boolean {
  const first = this._form.get('firstArrivalDate')?.value;
  const second = this._form.get('secondArrivalDate')?.value;
  const firstTime = this._form.get('firstTime')?.value;
  if (!first || !second || !firstTime) return false;
  return this.isSameDay(first, second);
}

/**
 * Parse a value into an HH:mm string. Handles Date instances, raw "HH:mm"
 * strings, and Date-like strings (e.g. "Mon Jul 06 2026 17:04:00 GMT-0400").
 * Returns null when the value cannot be parsed.
 */
private parseHHmm(raw: any): string | null {
  if (raw === null || raw === undefined || raw === '') return null;
  if (raw instanceof Date) return moment(raw).format('HH:mm');
  const str = String(raw).split(',')[0];
  if (/^\d{1,2}:\d{2}$/.test(str)) return str;
  const m = moment(str);
  return m.isValid() ? m.format('HH:mm') : null;
}

/**
 * Parse a value into a YYYY-MM-DD string. Handles Date instances and date
 * strings. Returns null when the value cannot be parsed.
 */
private parseDate(raw: any): string | null {
  if (raw === null || raw === undefined || raw === '') return null;
  if (raw instanceof Date) return moment(raw).format('YYYY-MM-DD');
  const str = String(raw).split(',')[0];
  const m = moment(str);
  return m.isValid() ? m.format('YYYY-MM-DD') : null;
}
  activeTimePicker: 'firstTime' | 'secondTime' | null = null;
  @Input() getClientsSettingAppBooking:any;
  isHovered = false;
  isHoveredCancelDate: boolean;
  isHoverConfirm: boolean;
  mesaggeErrorVisibleOrigin: boolean = false;
  mesaggeErrorVisibleDestination: boolean = false;
  oneWay: boolean = true;
  originInputValue: string = '';
  destinationInputValue: string = '';
  showModal: boolean = false;
  hover = false;
  titleModal: string = 'Advertencia';
  messageModal: string = 'Cree un file en la barra superior para poder iniciar una búsqueda';
  bsModalRef?: BsModalRef;
  componentResults: boolean = false;
  componentResultsFirstCharge: boolean = true;
  validateButtonSearch:boolean;
  messageTypeFlySelectedFirstTime: boolean = true;
  messageTypeFlySelectedSecondTime: boolean = true;

  searchPointToPoint: boolean = false;

  pointMessageOrigin: string = 'Traslado';
  pointMessageDestination: string = 'Traslado';

  countryIataOrigin:string;
  countryIataDestiny:string;

  countryPickupLocation: string;
  countryDropoffLocation: string;

  loadingData: boolean = false;
  routerStorage: any;
    bgClientColor: string;
    private destroy$ = new Subject<void>();
  private originSearchSub?: Subscription;
  private destinationSearchSub?: Subscription;
private closing = false;
private mouseDownTarget: EventTarget | null = null;

@HostListener('document:mousedown', ['$event'])
onDocumentMouseDown(event: MouseEvent) {
  this.mouseDownTarget = event.target;
}

@HostListener('document:click', ['$event'])
onClickOutside(event: MouseEvent) {
  // Si está cerrado o ya estamos cerrando, salir
  if (!this.isCollapsed || this.closing) {
    return;
  }

  // Ignore clicks that originated inside a text-editable element.
  // This covers Cmd+A / drag-to-select inside any <input>, <textarea>
  // or <select> belonging to the form: the `mousedown` happened there,
  // the `click` bubbles up to `document`, and we must NOT treat that
  // as a click-outside of the passenger card selector.
  const downOnTextField =
    this.mouseDownTarget instanceof HTMLInputElement ||
    this.mouseDownTarget instanceof HTMLTextAreaElement ||
    this.mouseDownTarget instanceof HTMLSelectElement;
  this.mouseDownTarget = null;
  if (downOnTextField) {
    return;
  }

  const clickedTrigger = this.triggerButton?.nativeElement.contains(event.target);
  const clickedSelector = this.cardSelectorRoom?.nativeElement.contains(event.target);

  // Si el clic NO fue en el trigger Y NO fue en el selector
  if (!clickedTrigger && !clickedSelector) {
    this.closing = true;
    this._confirm();
  }
}
  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    private _router: Router,
    private _restService: RestService,
    private _addressService: AddressesService,
    public vcr: ViewContainerRef,
    public userService:UserService,
    private notificationService: NotificationService,
    private _itineraryService: ItineraryService,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<TransportsComponent>
  ) {
  }


  ngOnInit() {
                const now = new Date();
                this.now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                this.dpConfig = { dateInputFormat: 'DD/MM/YYYY'  };
                this.minDate = new Date();
                this.minDate.setDate(this.minDate.getDate() + 1);
                this._maxPersons = Array.from(Array(100).keys());
                this.passengers = 'Pasajeros';
                this.routerStorage = setting.apiStorageBooking;
                this.componentResults = this.data && this.data?.component === 'results' ? true : false;
                     if(this.componentResults) {
                          this.loadingData = true;
                     }

                // (reactividad removida)
                this.clientData();
                this.initForm();



                 this._itineraryService.booleanValidateByStatus$.subscribe((res: any) => {
                   this.validateButtonSearch = res;
                 });

                  this._itineraryService.validateItineraryByStatus(this.userService.itineraryActive[0]);

                  this._itineraryService.itinerary$.pipe(takeUntil(this.destroy$)).subscribe(() => {
                    this.cdr.detectChanges();
                  });

// Enforce min-time (currentTime) when the trip is today.
// Covers both wheel emissions and programmatic setValue().
this._form.get('firstTime')?.valueChanges
  .pipe(takeUntil(this.destroy$))
  .subscribe((value: string | null) => {
    this.enforceMinTime('firstTime', value);
    // When pickup time changes, validate that the dropoff time still respects it.
    // Use setTimeout to defer to next tick so firstTime.value is fully propagated.
    setTimeout(() => this.reconcileSecondTimeAgainstFirstTime(), 0);
  });
this._form.get('secondTime')?.valueChanges
  .pipe(takeUntil(this.destroy$))
  .subscribe((value: string | null) => {
    // secondTime is only constrained by firstTime when same day, not by currentTime.
    this.enforceSecondTimeAboveFirstTime(value);
  });
this._form.get('secondArrivalDate')?.valueChanges
  .pipe(takeUntil(this.destroy$))
  .subscribe(() => {
    setTimeout(() => this.reconcileSecondTimeAgainstFirstTime(), 0);
  });
this._form.get('firstArrivalDate')?.valueChanges
  .pipe(takeUntil(this.destroy$))
  .subscribe(() => {
    setTimeout(() => this.reconcileSecondTimeAgainstFirstTime(), 0);
  });

  // Switch state from a previous session only matters for the edit-search
  // modal (`componentResults === true`). On a fresh `/home` visit, a stale
  // `transports-switch-state` would override the user's defaults, so we drop
  // it here and let `changeTypeSearch()` rebuild it when (and only when) the
  // user actually toggles a switch.
  if (!this.componentResults) {
    localStorage.removeItem('transports-switch-state');
  }
    }

    /**
     * If the trip is scheduled for today and the supplied time is earlier than
     * currentTime, snap the formControl back to currentTime and update the DOM.
     * Used to cover wheel emissions and any other programmatic value changes.
     */
    private enforceMinTime(controlName: 'firstTime' | 'secondTime', value: string | null): void {
      const fc = this._form.get(controlName);
      if (!fc || !value) return;
      const minAllowed = this.getMinAllowedTime(controlName);
      if (!minAllowed) return;
      if (this.isTimeBefore(value, minAllowed)) {
        if (value === this.currentTime) return;
        const nowParts = this.currentTime.split(':').map(n => parseInt(n, 10));
        const floorMinutes = (nowParts[0] || 0) * 60 + (nowParts[1] || 0) + 5;
        const hh = Math.floor(floorMinutes / 60) % 24;
        const mm = floorMinutes % 60;
        const floor = `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
        fc.setValue(floor);
        // Locate the trigger input by its data attribute to avoid placeholder collisions.
        const el = document.querySelector(
          `input[data-time-input="${controlName}"]`
        ) as HTMLInputElement | null;
        if (el) el.value = floor;
      }
    }

    /**
     * For secondTime: if pickup and dropoff are the same day and secondTime is
     * earlier than firstTime, snap secondTime back to currentTime. Skipped when
     * no firstTime is set yet (user has to enter pickup first).
     */
    private enforceSecondTimeAboveFirstTime(value: string | null): void {
      const fc = this._form.get('secondTime');
      if (!fc || !value) return;
      const floor = this.getSecondTimeFloor();
      if (!floor) return;
      if (this.isTimeBefore(value, floor)) {
        // Avoid infinite loop: if value already equals the reset target, no-op.
        if (value === floor) return;
        fc.setValue(floor);
        const el = document.querySelector(
          `input[data-time-input="secondTime"]`
        ) as HTMLInputElement | null;
        if (el) el.value = floor;
      }
    }

    /**
     * Triggered when firstTime or secondArrivalDate changes:
     * 1. If a return date is set but secondTime is null, populate it with
     *    currentTime so the trip has an actual dropoff time (without this,
     *    goSearch() would send dropoffTime:null even for round-trips, and
     *    checkFlight() would treat the missing value as minute 0).
     * 2. Re-validate the secondTime value and snap it to currentTime / firstTime
     *    if it is no longer valid.
     */
    private reconcileSecondTimeAgainstFirstTime(): void {
      const fc = this._form.get('secondTime');
      const hasReturnDate = !!this._form.get('secondArrivalDate')?.value;
      if (fc && hasReturnDate && !fc.value) {
        fc.setValue(this.currentTime);
      }
      const current = fc?.value;
      if (!fc || !current) return;
      this.enforceSecondTimeAboveFirstTime(current);
    }

    ngOnDestroy(): void {
        this.originSearchSub?.unsubscribe();
        this.destinationSearchSub?.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
    }

      ngAfterViewInit() {
    this.updateSliderCircleColor();
    this.updateSliderDestinationCircleColor();
         setTimeout(() => {
        this.setupAutocompleteStyles();
    });

    this.cdr.detectChanges();
  }


   updateSliderCircleColor() {
    const color = this.pointMessageOrigin === 'Traslado'
      ? this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1
      : 'white';

    if (this.sliderElement) {
      this.sliderElement.nativeElement.style.setProperty('--circle-color', color);
    }
  }


    private setupAutocompleteStyles(): void {
    if (this.auto) {
        this.auto.opened.subscribe(() => {
            setTimeout(() => {
                // Buscar todos los overlays y tomar el último (el más reciente)
                const overlays = document.querySelectorAll('.cdk-overlay-pane');
                const overlay = overlays[overlays.length - 1]; // El último abierto

                if (overlay) {
                    (overlay as HTMLElement).style.minWidth = '30%';
                    (overlay as HTMLElement).style.width = 'fit-content';
                    (overlay as HTMLElement).style.maxWidth = '90vw';
                }
            });
        });
    }

}

updateSliderDestinationCircleColor() {
  setTimeout(() => {
    const color = this.pointMessageDestination === 'Traslado'
      ? this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1
      : 'white';

    if (this.sliderDestinationElement) {
      this.sliderDestinationElement.nativeElement.style.setProperty('--circle-color-destination', color);
    } else {
      // Fallback: buscar por clase
      const slider = document.querySelector('.slider-s2');
      if (slider) {
        (slider as HTMLElement).style.setProperty('--circle-color-destination', color);
      }
    }
  });
}

  // sliderDestinationElement

                  /**
 * Inicializa los datos del cliente desde los datos proporcionados o configuración global
 *
 * Este método extrae y configura la información del cliente desde los datos de entrada
 * y establece el color principal del cliente para personalización de la UI.
 *
 * @returns {void}
 *
 * @dataSource
 * - Primero intenta obtener datos de `this.data.clientSetting`
 * - Si no existe, usa la configuración global del cliente
 *
 * @properties
 * - getClientsSettingAppBooking: Almacena la configuración completa del cliente
 * - bgClientColor: Establece el color principal para estilos UI (#color_main_1)
 *
 * @dependencies
 * - Requiere `this.data` con propiedad `clientSetting`
 * - Requiere estructura de cliente con `clients_setting_global.color_main_1`
 *
 * @example
 * // Configuración típica:
 * this.data = {
 *   clientSetting: {
 *     clients_setting_global: {
 *       color_main_1: '#FF5733'
 *     }
 *   }
 * };
 * this.clientData(); // bgClientColor = '#FF5733'
 */
  clientData(): void {
    if(this.data && this.data?.clientSetting) {
                  this.getClientsSettingAppBooking = this.data?.clientSetting;
                }
    this.bgClientColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
  }


/**
 * Método para inicializar el formulario
 *
 * Este método crea un formulario reactivo en Angular con validaciones y valores por defecto.
 * También configura suscriptores para manejar cambios en los campos de origen y destino.
 *
 * @loading-> Estado del spinner
 */
async initForm() {
  this._form = this.fb.group({
    type: ['oneTrip', Validators.required],
    firstOrigin: [null, [Validators.required, this.validateAutocompleteSelectionOrigin()]],
    firstDestination: [null, [Validators.required, this.validateAutocompleteSelectionDestination()]],
    pickUp: ['',], // Validators.required
    dropOff: ['', ],//Validators.required
    firstArrivalDate: [this.now],
    firstTime: [this.currentTime, Validators.required],
    firstqtyAdults: [1, [Validators.required, Validators.min(1)]],
    firstqtyChilds: [0, Validators.required],
    firstchildsage: this.fb.array([]),
    secondArrivalDate: [null],
    secondTime: [null],
    rideHailing: [false]
  });

  await this.handleChange('oneTrip');

  this.generateSearchLocation(false, 'origin');
  this.generateSearchLocation(false, 'destination');


   if(this.componentResults) {
                      if(this.componentResultsFirstCharge) {
                        this.formPatchValue();
                        this.componentResultsFirstCharge = false;
                      }

                    } else {
                      this._form.get('firstOrigin').setErrors({error: true});
                      this._form.get('firstDestination').setErrors({error: true});
                    }

}

/**
 * Parchea el formulario con valores provenientes de datos existentes para transfers (categoría 8)
 *
 * Este método reconstruye y popula el formulario de transfers con datos preexistentes,
 * manejando específicamente la categoría 8 (Transfers) con parsing de fechas y configuración
 * de ubicaciones.
 *
 * @returns {void}
 *
 * @prerequisites
 * - Requiere `this.data` con propiedad `category` igual a 8
 * - Requiere `this.data.payload[0]` con estructura específica de transfers
 *
 * @process
 * 1. ✅ Parsing de fechas desde strings en formato YYYY-MM-DD
 * 2. ✅ Determinación de tipo de viaje (oneTrip vs roundTrip)
 * 3. ✅ Patch de valores al formulario con datos de transfers
 * 4. ✅ Obtención de ubicaciones mediante `getLocationsAll`
 *
 * @dateParsing
 * - firstArrivalDate: Desde payload.pickupDate
 * - secondArrivalDate: Desde payload.dropoffDate (solo si existe dropoffTime)
 *
 * @tripTypeLogic
 * - roundTrip: Si existe payload.transfers.dropoffTime
 * - oneTrip: Si no existe dropoffTime
 *
 * @additionalData
 * - firstTime/secondTime: Horas de pickup/dropoff
 * - Passenger data: adults, children, ages
 * - Location data: pickupLocation, dropoffLocation
 */
formPatchValue(): void {
  if(this.data && this.data?.category) {

    if(!this.data.payload) {
      this.loadingData = false;
      return;
    }

    if(this.data.category !== this.data.payload[0].categoriesId[0]) {
      this.loadingData = false;
      return;
    }
    const payload = this.data.payload[0];



    if(!payload) {
      this.loadingData = false;
      return;
    }
                  let firstArrival: Date;
                  let secondArrival: Date;
                  if (payload.pickupDate) {
                    const [firstArrivalYear, firstArrivalMonth, firstArrivalDay] = payload.pickupDate.split('-');
                    firstArrival = new Date(Number(firstArrivalYear), Number(firstArrivalMonth) - 1, Number(firstArrivalDay));
                  } else {
                    firstArrival = new Date();
                  }

                  if(payload && payload?.dropoffDate) {
                    const [secondArrivalYear, secondArrivalMonth, secondArrivalDay] = payload.dropoffDate.split('-');
                    secondArrival = new Date(Number(secondArrivalYear), Number(secondArrivalMonth) - 1, Number(secondArrivalDay));
                  } else {
                    secondArrival = new Date();
                  }

                  // Asignación al formulario
                  const hasReturnLeg = !!payload?.dropoffDate;
                  this._form.patchValue({
                    type: hasReturnLeg ? 'roundTrip' : 'oneTrip',
                    firstArrivalDate: firstArrival,
                    secondArrivalDate: hasReturnLeg ? secondArrival : null,
                    firstTime: this.parseHHmm(payload?.transfers?.pickupTime),
                    secondTime: hasReturnLeg
                      ? (this.parseHHmm(payload?.transfers?.dropoffTime) || this.currentTime)
                      : null,
                    firstchildsage: payload?.transfers?.paxList.children ?? [],
                    firstqtyChilds: payload?.transfers?.paxList.children?.length,
                    firstqtyAdults: payload?.transfers?.paxList.adults,
                    firstOrigin: payload?.transfers?.pickupLocation,
                    firstDestination: payload?.transfers?.dropoffLocation,
                    rideHailing: payload?.transfers?.rideHailing ?? false
                  });
                  this.setPassanger();

                  const childAges: any[] = (payload?.transfers?.paxList?.children ?? [])
                    .map((age: any) => Number(age));
                  this.adjustChildrenAges(childAges.length);
                  const agesArray = this._form.get('firstchildsage') as any;
                  childAges.forEach((age: number, i: number) => {
                    if (agesArray.at(i)) {
                      agesArray.at(i).get('age').setValue(age);
                    }
                  });

                  this.cdr.detectChanges();

                  if (payload?.transfers?.rideHailing) {
                    this.typeSearch('realTime');
                  }

                  if (this.data.formTransport?.firstOrigin) {
                    this.getLocationsAll({data: this.data.formTransport.firstOrigin, type: this.data.formTransport.firstOrigin.type}, 'origin');
                  }
                  if (this.data.formTransport?.firstDestination) {
                    this.getLocationsAll({data: this.data.formTransport.firstDestination, type: this.data.formTransport.firstDestination.type}, 'destination');
                  }

                  const switchStateRaw = localStorage.getItem('transports-switch-state');
                  if (switchStateRaw) {
                    try {
                      const switchState = JSON.parse(switchStateRaw);
                      if (switchState?.origin === 'Domicilio') {
                        this.pointMessageOrigin = 'Domicilio';
                        this.generateSearchLocation(true, 'origin');
                      }
                      if (switchState?.destination === 'Domicilio') {
                        this.pointMessageDestination = 'Domicilio';
                        this.generateSearchLocation(true, 'destination');
                      }
                      this.updateSliderDestinationCircleColor();
                      this.updateSliderCircleColor();
                    } catch (e) {
                      console.error('[transports] Error parsing switch state:', e);
                    }
                  }

                  this.loadingData = false;

    }
}

/**
 * Convierte una configuración de pasajeros en un FormArray reactivo con validaciones
 *
 * Este método transforma un objeto de configuración de pasajeros (adultos y niños)
 * en una estructura de FormArray con FormGroups para manejo en formularios reactivos.
 *
 * @param {any} configuration - Objeto con configuración de pasajeros a convertir
 * @returns {FormArray} - FormArray reactivo listo para usar en formulario
 *
 * @structure
 * FormArray con un FormGroup que contiene:
 * - qtyAdults: Cantidad de adultos (number, requerido)
 * - qtyChilds: Cantidad de niños (number, basado en children array length)
 * - childsage: FormArray de niños → FormGroup por niño con:
 *   - age: Edad del niño (0-17, requerido)
 *   - id: Identificador único (index-based)
 *
 * @validations
 * - qtyAdults: Validators.required
 * - age:
 *   - Validators.required (campo obligatorio)
 *   - Validators.min(0) (edad mínima 0 años)
 *   - Validators.max(17) (edad máxima 17 años)
 *
 * @transformation
 * - Convierte configuration object → FormArray
 * - Mapea children array → FormArray de edades
 * - Calcula qtyChilds automáticamente desde el array length
 *
 * @example
 * // Input:
 * {
 *   adults: 2,
 *   children: [5, 8]
 * }
 *
 * // Output:
 * FormArray([
 *   FormGroup({
 *     qtyAdults: 2,
 *     qtyChilds: 2,
 *     childsage: FormArray([
 *       FormGroup({ age: 5, id: 0 }),
 *       FormGroup({ age: 8, id: 1 })
 *     ])
 *   })
 * ])
 */
getConfigurationPassenger(configuration: any): FormArray {
  const passengerFormArray = this.fb.array([]);


    const childsAgesArray = this.fb.array([]); // Crea un FormArray vacío

    if (configuration.children && Array.isArray(configuration.children)) {
      configuration.children.forEach((age, index) => {
        childsAgesArray.push(
          this.fb.group({
            age: [
              age,
              Validators.compose([
                Validators.required,
                Validators.min(0),
                Validators.max(17)
              ])
            ],
            id: [index]
          })
        );
      });
    }

    passengerFormArray.push(
      this.fb.group({
        qtyAdults: [Number(configuration.adults) || 1, Validators.required],
        qtyChilds: [childsAgesArray.length || 0],
        childsage: childsAgesArray // Asigna directamente el FormArray
      })
    );


  return passengerFormArray;
}

/**
* Método para validar la selección en un autocomplete
*
* @returns ValidatorFn - Retorna un validador que verifica si el valor es un objeto válido.
*/
validateAutocompleteSelectionOrigin(): ValidatorFn {
  return (control: AbstractControl) => {
      if (!control.value || typeof control.value !== 'object') {
        this.mesaggeErrorVisibleOrigin = true;
        return { invalidSelection: true }; // Error si el valor no es un objeto
      }
      this.mesaggeErrorVisibleOrigin = false;
      return null; // Válido si el valor es un objeto (opción seleccionada)
  };
}

/**
* Método para validar la selección en un autocomplete
*
* @returns ValidatorFn - Retorna un validador que verifica si el valor es un objeto válido.
*/
validateAutocompleteSelectionDestination(): ValidatorFn {
  return (control: AbstractControl) => {
      if (!control.value || typeof control.value !== 'object') {
        this.mesaggeErrorVisibleDestination = true;
        return { invalidSelection: true }; // Error si el valor no es un objeto
      }
      this.mesaggeErrorVisibleDestination = false;
      return null; // Válido si el valor es un objeto (opción seleccionada)
  };
}

/**
 * Maneja el cambio de tipo de viaje (ida o ida y vuelta)
 *
 * @param evt - Tipo de viaje seleccionado ('oneTrip' o 'roundTrip')
 */
handleChange(evt: any) {
  if (evt === 'roundTrip') {
     this.isOpen = true;
     this._form.get('secondArrivalDate').setValidators(Validators.compose([
       Validators.required,
       (c: FormControl) => {
         if (
           this._form !== undefined &&
           c.value !== null &&
           this._form.get('firstArrivalDate').value !== null &&
           this._form.get('firstArrivalDate').value !== undefined
         ) {
           const valid = (c.value >= this._form.get('firstArrivalDate').value) ? null : { invalidDate: true };
           this._form.controls['firstArrivalDate'].setErrors(valid);
           return valid;
         }
       }
     ]));
      this._form.get('secondTime').setValidators(Validators.required);
      this._form.get('secondArrivalDate').updateValueAndValidity();
      this._form.get('secondTime').updateValueAndValidity();
  } else {
      this.isOpen = false;
      this._form.get('secondArrivalDate').clearValidators();
      this._form.get('secondArrivalDate').updateValueAndValidity();
      this._form.get('secondTime').clearValidators();
      this._form.get('secondTime').updateValueAndValidity();
  }
}

/**
 * Verifica la validez de las fechas y horarios de los vuelos y traslados.
 *
 * @returns {boolean} `true` si los datos son válidos, `false` si hay errores.
 */
checkFlight(): boolean {
  if (this._form.get('rideHailing')?.value) {
    return true;
  }
  let result = true;
  const a = this._form; // Obtiene los valores del formulario

  let firstArrivalDate: string;
  let secondArrivalDate: string | null = null; // Inicializa en `null` si es un viaje de ida
  let firstTime: string;
  let secondTime: string;
  let arrivalHourIn: string;
  let arrivalDateIn: string;
  let departureHourOut: string;
  let departureDateOut: string;
  let st: number = 0; // Inicializa `st` en 0 para evitar errores si no se asigna
  let ft: number;
let message: string = '';

  firstArrivalDate = this.parseDate(a.value['firstArrivalDate']);
  firstTime = this.parseHHmm(a.value['firstTime']);

  // Convierte la hora a minutos totales en el día (Ej: 14:30 → 870 minutos)
  if (firstTime) {
    ft = parseInt(firstTime.split(':')[0], 10) * 60 + parseInt(firstTime.split(':')[1], 10);
  }

  // Calculate secondArrivalDate/secondTime regardless of trip type so the
  // validations below can run whenever the user has set a return date+time
  // (even if the form's `type` field is still the default 'oneTrip').
  if (a.value['secondArrivalDate']) {
    secondArrivalDate = this.parseDate(a.value['secondArrivalDate']);
  }
  if (a.value['secondTime']) {
    secondTime = this.parseHHmm(a.value['secondTime']);
    if (secondTime) {
      st = parseInt(secondTime.split(':')[0], 10) * 60 + parseInt(secondTime.split(':')[1], 10);
    }
  }
  if (firstArrivalDate > (secondArrivalDate || firstArrivalDate)) {
      result = false;
      message = `Error, ingrese una fecha de recogida de ida anterior a la de regreso: ${firstArrivalDate}`;
  }

  if ((ft > st) && (firstArrivalDate === secondArrivalDate)) {
      result = false;
      message = `Error, ingrese una hora de recogida de ida anterior a la de regreso: ${secondTime}`;
  }

  const todayStr = moment(new Date()).format('YYYY-MM-DD');
  const nowMs = new Date();
  const currentMinutes = nowMs.getHours() * 60 + nowMs.getMinutes();

  if (firstArrivalDate === todayStr && ft < currentMinutes) {
      result = false;
      const bothSet = !!secondTime && secondArrivalDate === todayStr && st < currentMinutes;
      message = bothSet
        ? `Error, la hora de ida y/o vuelta especificada, no puede ser anterior a la hora actual, ${this.currentTime}`
        : `Error, la hora de ida especificada, no puede ser anterior a la hora actual, ${this.currentTime}`;
  }

  // When a return date is set (regardless of trip type), secondTime must respect firstTime
  // when pickup and dropoff fall on the same day.
  if (secondArrivalDate && firstArrivalDate === secondArrivalDate && ft > st) {
      result = false;
      message = `La hora de vuelta no puede ser anterior a la hora de salida cuando el traslado es el mismo día. Seleccione una hora igual o posterior a ${firstTime}.`;
  }

  // if ((this._itineraryService.itinerary.fly && this._itineraryService.itinerary.fly.id)) {
  //     // Obtiene los datos del vuelo
  //
  //     if(this._itineraryService.itinerary.fly?.arrivalIn) {
  //       arrivalDateIn = moment(this._itineraryService.itinerary.fly?.arrivalIn.toString().split(',')[0]).format('YYYY-MM-DD');
  //
  //       arrivalHourIn = moment(this._itineraryService.itinerary.fly?.arrivalIn.toString().split(',')[0]).format('HH:mm');
  //
  //     }
  //     const at = parseInt(arrivalHourIn?.split(':')[0], 10) * 60 + parseInt(arrivalHourIn?.split(':')[1], 10);
  //
  //     if(this._itineraryService.itinerary.fly?.departureOut) {
  //       departureDateOut = moment(this._itineraryService.itinerary.fly?.departureOut.toString().split(',')[0]).format('YYYY-MM-DD');
  //       departureHourOut = moment(this._itineraryService.itinerary.fly?.departureOut.toString().split(',')[0]).format('HH:mm');
  //     }
  //
  //     const _at = parseInt(departureHourOut?.split(':')[0], 10) * 60 + parseInt(departureHourOut?.split(':')[1], 10);
  //     if(firstArrivalDate && arrivalDateIn) {
  //       // Verifica si el primer traslado es antes de la llegada del vuelo
  //       if (firstArrivalDate > arrivalDateIn) {
  //           result = false;
  //           message = `Error, la fecha de recogida de ida debe ser anterior a la llegada del vuelo: ${arrivalDateIn}`;
  //       }
  //     }
  //     else if(firstArrivalDate && arrivalDateIn && ft && at) {
  //       // Ajuste de tiempo mínimo de espera (1 hora y 15 minutos) entre el traslado y el vuelo
  //       ft = ft + 75;
  //       if ((ft > at) && (firstArrivalDate === arrivalDateIn)) {
  //           result = false;
  //           message = `Error, la hora de recogida de ida debe ser al menos 1h 15min antes de la llegada del vuelo: ${arrivalHourIn}`;
  //       }
  //     }
  //     else if(secondArrivalDate && secondArrivalDate && departureDateOut) {
  //
  //       // Verifica si el segundo traslado es después de la salida del vuelo
  //       if (secondArrivalDate && secondArrivalDate > departureDateOut) {
  //           result = false;
  //           message = `Error, la fecha de recogida de regreso debe ser anterior a la salida del vuelo: ${departureDateOut}`;
  //       }
  //     }
  //     else if(secondArrivalDate && departureDateOut && st && _at) {
  //       // Ajuste de tiempo mínimo de espera (3 horas y 30 minutos) entre el traslado y la salida del vuelo
  //       st = st + 210;
  //       if ((st > _at) && (secondArrivalDate === departureDateOut)) {
  //           result = false;
  //           message = `Error, la hora de recogida de regreso debe ser al menos 3h 30min antes de la salida del vuelo: ${departureHourOut}`;
  //       }
  //
  //     } else {
  //       return true;
  //     }
  // }

  if(message !== '') {
    this.notificationService.info(message);
  }

  return result;
}


/**
 * Método para manejar el envío del formulario.
 *
 * Este método se llama cuando el formulario es enviado. Verifica si el vuelo es válido
 * y si es así, limpia el mensaje y llama al método de búsqueda.
 *
 * @param form -> FormGroup: El grupo de controles del formulario.
 * @param event -> Event (opcional): El evento que desencadena el envío del formulario.
 * @param dummy -> Object (opcional): Parámetro adicional que podría utilizarse en el futuro.
 */
_onSubmit(form: FormGroup, event?: Event, dummy?: Object) {
  // If the user picked a return date but never touched the return-time field,
  // secondTime is still null even though the form visually shows currentTime.
  // checkFlight() reads form.value['secondTime'] and treats null as minute 0,
  // which fails the same-day validation. Backfill it with currentTime right
  // before validation so round-trip submits work without forcing the user to
  // type or click into the return-time field first.
  const secondArrivalDate = form.get('secondArrivalDate')?.value;
  const secondTimeCtrl = form.get('secondTime');
  if (secondArrivalDate && secondTimeCtrl && !secondTimeCtrl.value) {
    secondTimeCtrl.setValue(this.currentTime);
  }

  if (this.checkFlight()) {
    this.goSearch(form, event, dummy);
  }
}

/**
 * Método para realizar la búsqueda de transportes.
 *
 * Este método verifica si las ciudades de origen y destino son válidas, y luego
 * construye un payload para enviar una solicitud POST al backend con la información
 * del formulario. Si la solicitud es exitosa, maneja la respuesta y navega a los resultados.
 *
 * @param form -> FormGroup: El grupo de controles del formulario.
 * @param event -> Event (opcional): El evento de la búsqueda.
 * @param dummy -> Object (opcional): Parámetro adicional.
 */
  goSearch(form: FormGroup, event?: Event, dummy?: Object) {

    this.originValue = ((this.selectediataCodeOrigin !== undefined) && (this.selectediataCodeOrigin !== null));
    this.destineVale = ((this.selectediataCodeDestiny !== undefined) && (this.selectediataCodeDestiny !== null));
    if ((this.originValue) && (this.destineVale)) {
      if (event) {
        event.preventDefault();
      }
      this._emitLoading(true);
      const payload = this._payload(form, this.selectediataCodeDestiny, this.selectediataCodeOrigin);

        payload['transfers']['pickupLocation']['originDateTransfers'] = this.messageTypeFlySelectedFirstTime ? payload['transfers']['pickupLocation']['type'] : 'pickup';
        payload['transfers']['dropoffLocation']['originDateTransfers'] = this.messageTypeFlySelectedSecondTime ? payload['transfers']['pickupLocation']['type'] : 'pickup';

      payload['transfers']['oneWay'] = payload['transfers']['dropoffTime'] ? false : true;
      this.oneWay = payload['transfers']['dropoffTime'] ? false : true;


      if (localStorage.getItem("form")) {
        localStorage.removeItem("form");
      }
      localStorage.setItem("form", JSON.stringify(form.value));
      const payloadArray = [payload];

      if (localStorage.getItem("payload")) {
        localStorage.removeItem("payload");
      }

      localStorage.setItem("payload", JSON.stringify(payloadArray));

      if(!this.oneWay) {
         if (localStorage.getItem("wayTransfer")) {
          localStorage.removeItem("wayTransfer");
          localStorage.removeItem("returnTransferForm");
          localStorage.removeItem("returnTransferPayload");
         }
        localStorage.setItem("wayTransfer", JSON.stringify([{pickup: form.get('firstOrigin').value, dropoff: form.get('firstDestination').value}]));
        localStorage.setItem("returnTransferForm",  JSON.stringify(this.returnTrasferParse('form')));
        localStorage.setItem("returnTransferPayload", JSON.stringify(this.returnTrasferParse('payload')));

      } else {
         if (localStorage.getItem("wayTransfer")) {
          localStorage.removeItem("wayTransfer");
          localStorage.removeItem("returnTransferForm");
          localStorage.removeItem("returnTransferPayload");
         }
      }


      if(this.componentResults) {
            localStorage.setItem('origin', 'TRANSPORTS');
            this.dialogRef.close(payload);
      } else {
        this._restService.doPost('app', 'search', payload).subscribe(
          (response:any) => {
            this.payload.emit(payloadArray);
            if (response !== null && response.results && response.results.length > 0) {
              this._colocarSearchIdEnlosHoteles(response);
              this._handleResponse(response, 'TRANSPORTS', form);
              this._emitOrigin('TRANSPORTS');
              this._emitLoading(false);
              this._router.navigate(['/results']);
             } else {
              setTimeout(() => {
                    this._emitLoading(false);
                        const initialState: ModalOptions = {
                          initialState: {
                            message: '',
                            confirmText: 'Cerrar',
                            cancelText: 'Volver a intentar',
                            showCancelButton: true,
                            size: 'sm',
                          }
                        };
                        const modalOptions = Object.assign({}, initialState, this.config);
                        this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);


                        const confirmSubscription = this.bsModalRef?.content?.confirmResult.subscribe((result: boolean) => {
                        if (!result) {
                          this._onSubmit(form, event);
                        } else {
                          this.bsModalRef.hide();
                          this._router.navigate(["/home"]);
                        }
                     });
                       }, 3000);
                      }
          },
          error => {

            setTimeout(() => {
                  this._emitLoading(false);
             const initialState: ModalOptions = {
              initialState: {
                message: 'Ocurrió un error al intentar encontrar productos. Inténtalo de nuevo'
              }
            };

            this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);

            const confirmSubscription = this.bsModalRef?.content?.confirmResult.subscribe((result: boolean) => {
              if (!result) {
                this._onSubmit(form, event);
              } else {
                this.bsModalRef.hide();
                this._router.navigate(["/home"]);
              }
              confirmSubscription.unsubscribe();
            });

            }, 3000);
               });

      }
    } else {
      // tslint:disable-next-line:curly
      if (!this.originValue) {
        this._form.get('firstOrigin').setErrors({ invalidDestination: true });
      }
      if (!this.destineVale) {
        this._form.get('firstDestination').setErrors({ invalidDestination: true });
      }

    }
  }


  /**
 * Método para generar la información de retorno del transfer
 *
 * Este método construye un arreglo con los datos necesarios para el retorno del transfer,
 * ya sea en formato de formulario o en formato de payload para el backend.
 *
 * @type -> string que define el tipo de estructura a retornar ('form' o 'payload')
 * @return -> devuelve un array de objetos con la estructura de formulario o payload
 */

      returnTrasferParse(type: string): any[] {

        const returnData: any[] = [];

        switch(type) {
          case 'form':
                  returnData.push({
                    'firstOrigin': this._form.get('firstDestination').value,
                    'firstDestination': this._form.get('firstOrigin').value,
                    'pickUp': this._form.get('dropOff').value,
                    'dropOff': this._form.get('pickUp').value,
                    'firstArrivalDate': this._form.get('secondArrivalDate').value,
                    'firstTime': this._form.get('secondTime').value,
                    'secondArrivalDate': this._form.get('secondArrivalDate').value,
                    'secondTime': this._form.get('secondTime').value,
                    'firstqtyAdults': this._form.get('firstqtyAdults').value,
                    'firstqtyChilds': this._form.get('firstqtyChilds').value,
                    'firstchildsage': this._form.get('firstchildsage').value
                  });
                  break;
          case 'payload':
                  returnData.push({
                    'categoriesId': [8],
                    'dropoffDate': this.getFormattedDate(this._form.value['secondArrivalDate'], 'date'),
                    'market': 2,
                    'oldReservationId': null,
                    'pickupDate': this.getFormattedDate(this._form.value['secondArrivalDate'], 'date'),
                    'providersId': null,
                    'transfers': {
                      'rideHailing': this._form.get('rideHailing').value,
                      'pickupTime': this._form.get('secondTime').value,
                      'dropoffTime': this._form.get('secondTime').value,
                      'pickupLocation': {
                        'id': this.dropoff['id'],
                        'address': this.dropoff['address'],
                        'type': this.dropoff['type'],
                        'origin': this.dropoff['destination'],
                        'name': this.dropoff['name'],
                        'longitude': this.dropoff['longitude'],
                        'latitude': this.dropoff['latitude'],
                      },
                      'dropoffLocation': {
                        'id': this.pickup['id'],
                        'address': this.pickup['address'],
                        'type': this.pickup['type'],
                        'destination': this.pickup['origin'],
                        'name': this.pickup['name'],
                        'longitude': this.pickup['longitude'],
                        'latitude': this.pickup['latitude'],
                      },
                      paxList: {
                        adults: +this._form.value['firstqtyAdults'],
                        children: this.getAges(this._form.value['firstchildsage'])
                      },
                      oneWay: this.oneWay
                    }
                  });
                  break;
        }

        return returnData;

      }


      /**
 * Emitir estado de carga
 *
 * Este método emite un valor booleano que representa si una operación de carga
 * está activa o no. Se utiliza para mostrar o esconder indicadores de carga en la UI.
 *
 * @isLoading -> booleano que indica si se está cargando información
 */

  _emitLoading(isLoading: boolean) {
    this._findData = isLoading;
    this.isLoading.emit(isLoading);
  }

  /**
 * Agrega el `searchId` a cada resultado de hoteles
 *
 * Este método recorre cada objeto en `response.results` y le asigna el valor
 * de `response.searchId`. Esto permite mantener trazabilidad del resultado con su búsqueda.
 *
 * @response -> respuesta de la búsqueda con resultados y searchId
 */

  _colocarSearchIdEnlosHoteles(response: any) {
    response.results.forEach(obj => {
      obj.searchId = response.searchId;
    });
  }

  /**
 * Manejar respuesta del servicio
 *
 * Este método evalúa la respuesta del backend, y si contiene resultados, los procesa
 * para agregarlos al array de resultados y emitirlos. También anexa información como
 * el nombre de la categoría, la fecha de llegada y el formulario original.
 *
 * @response -> respuesta del backend con resultados
 * @categoryName -> nombre de la categoría (ej: 'HOTELS')
 * @form -> formulario utilizado en la búsqueda
 */

  _handleResponse(response: any, categoryName: string, form: FormGroup) {
    if (response && response.results != null) {
      try {
        this._resultsQuery = response.results;
        this._resultsQuery.categoryName = categoryName;
        this._resultsQuery.arrivalDate = this.datePipe.transform(form.value['firstArrivalDate'], 'yyyy-MM-dd');

        if (!response.results.length) {
          this._resultsQuery.noResultMessage = 'No results found for the search';
        }
        // // se anexa el formulario actual
        this._resultsQuery.form = form;
        const arrayResults = [this._resultsQuery];
        this.results.emit(arrayResults);
      } catch (e) {
        this._resultsQuery = [];
        this._restService.page = 1;
      }
    } else {
      this._resultsQuery = [];
      this._resultsQuery.noResultMessage = 'No results found for the search';
      this.results.emit(this._resultsQuery);
    }
  }

  /**
   * Resolves the dropoffTime that goes into the search payload.
   *
   * The pickup-time control is pre-populated with currentTime on form init,
   * but secondTime starts null and only gets populated when the user either
   * types in the manual input and blurs, or scrolls/commits the wheel
   * picker. If the user picks a return date and hits Search without ever
   * touching the return-time field, secondTime stays null and the backend
   * receives a round-trip request with no dropoffTime — which is exactly
   * what was happening in production (localStorage showed dropoffTime:null
   * after a round-trip search).
   *
   * Fix: when secondArrivalDate is set, default secondTime to currentTime
   * so the payload always carries a dropoffTime for round-trip searches.
   * When secondArrivalDate is null, this is a one-way and dropoffTime
   * correctly stays null.
   */
  getDropoffTime(form: FormGroup): string | null {
    const hasReturnDate = !!form.value['secondArrivalDate'];
    if (!hasReturnDate) return null;
    return form.value['secondTime'] || this.currentTime;
  }

  /**
  * Construye el payload para transporte
  *
  * Este método genera el objeto `payload` con todos los datos necesarios
  * para hacer una reserva de transporte (pick-up y drop-off) incluyendo
  * fechas, horarios, origen, destino y pasajeros.
  *
  * @form -> FormGroup con los datos ingresados en el formulario
 * @iataCodeDestiny -> código IATA del destino
 * @iataCodeOrigin -> código IATA del origen
 * @pickup -> objeto con información del lugar de recogida
 * @dropoff -> objeto con información del lugar de destino
 * @return -> objeto `payload` estructurado para la reserva
 */

  _payload(form: FormGroup, iataCodeDestiny: string, iataCodeOrigin: string): Object {

    const payloadTransport = [];
    const payload = {
      providersId: this.userService._providerId,
      oldReservationId:null,
      categoriesId: [8],
      pickupDate: this.getFormattedDate(form.value['firstArrivalDate'], 'date'),
      dropoffDate: this.getFormattedDate(form.value['secondArrivalDate'], 'date'),
      market:2, //cambiar a 2
      transfers: {
          rideHailing: form.value['rideHailing'],
          pickupTime: this.getFormattedDate(form.value['firstTime'], 'time'),
          dropoffTime: this.getDropoffTime(form),
          pickupLocation: {
            id: this.pickup['id'],
            address: this.pickup['address'],
            type: this.pickup['type'],
            origin:  this.pickup['origin'] || this.countryIataOrigin,
            name: this.pickup['name'],
            longitude: this.pickup['longitude'],
            latitude: this.pickup['latitude'],
          },
          dropoffLocation: {
            id: this.dropoff['id'],
            address: this.dropoff['address'],
            type:this.dropoff['type'],
            destination: this.dropoff['destination'] || this.countryIataDestiny,
            name: this.dropoff['name'],
            longitude: this.dropoff['longitude'],
            latitude: this.dropoff['latitude'],
          },
          paxList: {
            adults: +form.value['firstqtyAdults'],
            children: this.getAges(form.value['firstchildsage'])
          },
          oneWay: this.oneWay
        }
    };
    payloadTransport.push(payload);
    return payload;
  }

  /**
 * Devuelve un array de edades a partir de un array de objetos
 *
 * Este método toma un arreglo de objetos con la propiedad `age` y devuelve
 * un arreglo plano sólo con los valores de edad.
 *
 * @ages -> Array de objetos con estructura { age: number }
 * @return -> Array con solo los valores de edad
 */

  getAges(ages: Array<any>): any {
    const _ages = [];
    ages.forEach(age => {
      _ages.push(age['age']);
    });
    return _ages;
  }

  /**
 * Formatea una fecha según el formato indicado
 *
 * Si se solicita el formato 'time', se devuelve en formato 'HH:mm'.
 * Si se solicita otro, se devuelve en formato 'yyyy-MM-dd'.
 * Si la fecha está vacía, utiliza la del campo 'firstArrivalDate' como fallback.
 *
 * @date -> fecha a formatear
 * @format -> tipo de formato ('time' o por defecto 'date')
 * @return -> string formateado según el tipo especificado
 */

getFormattedDate(date: any, format: string): any {

  if(!date) {
    return null;
  }

  if (format === 'time') {
    // Si es string con formato HH:MM, devolverlo formateado
    if (typeof date === 'string' && /^\d{1,2}:\d{2}$/.test(date)) {
      const [hours, minutes] = date.split(':');
      return `${hours.padStart(2, '0')}:${minutes}`;
    }

    // Si es Date o string con fecha completa
    const dateObj = date instanceof Date ? date : new Date(date);
    return !isNaN(dateObj.getTime())
      ? this.datePipe.transform(dateObj, 'HH:mm')
      : this.currentTime;
  } else {
    const dateObj = date instanceof Date ? date : new Date(date);
    return !isNaN(dateObj.getTime())
      ? this.datePipe.transform(dateObj, 'yyyy-MM-dd')
      : this.datePipe.transform(this._form.get('firstArrivalDate')?.value, 'yyyy-MM-dd');
  }
}

  /**
 * Establece una fecha un día posterior a la fecha de llegada inicial
 *
 * Este método toma el valor del campo 'firstArrivalDate' del formulario,
 * le suma un día y retorna la nueva fecha en formato `yyyy-MM-dd`.
 *
 * @originValue -> valor actual del campo 'firstArrivalDate' (puede ser null)
 * @originDateArrival -> instancia de Date construida a partir de originValue
 * @return -> string con la fecha incrementada o vacío si no hay valor
 */

  setDateNullSecondArrival(): string {
    const originValue = this._form.get('firstArrivalDate').value;

    if (!originValue) return '';

    const originDateArrival = new Date(originValue);

    // Sumar un día
    originDateArrival.setDate(originDateArrival.getDate() + 1);

    // Formatear la fecha como yyyy-MM-dd
    return this.datePipe.transform(originDateArrival, 'yyyy-MM-dd');
  }

/**
 * Emite el origen seleccionado
 *
 * Este método emite el valor recibido como `origin` a través del `EventEmitter`.
 *
 * @origin -> objeto con los datos del origen seleccionado
 */

  _emitOrigin(origin: any) {
    this.origin.emit(origin);
  }

  /**
 * Agrega o elimina controles de edad para niños según cantidad seleccionada
 *
 * Este método ajusta dinámicamente los elementos del `FormArray` relacionado
 * a la edad de los niños. Si la cantidad seleccionada es mayor a los existentes,
 * se agregan nuevos; si es menor, se eliminan.
 *
 * @key -> nombre del `FormArray` en el formulario (por ejemplo 'childAges')
 * @key2 -> nombre del campo que indica la cantidad seleccionada (por ejemplo 'children')
 */

  _addChild(key: string, key2: string) {
    setTimeout(() => {
      const ages: any = this._form.get(key) as FormArray;
      const qty: number = +this._form.value[key2];
      if (qty > ages.length) {
        for (let i = ages.length; i < qty; i++) {
          ages.push(this.fb.group({
            id: [i],
            age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])],
          }));
        }
      } else {
        for (let i = ages.length - 1; i >= qty; i--) {
          ages.removeAt(i);
        }
      }
    }, 10);
  }

  /**
 * Devuelve los controles de un FormArray
 *
 * Utilizado para iterar sobre los controles dentro de un `FormArray`
 * en una plantilla o lógica de componentes.
 *
 * @form -> instancia de `FormGroup`
 * @key -> nombre del control que contiene el `FormArray`
 * @return -> lista de controles dentro del `FormArray`
 */

  formArray(form: FormGroup, key: string) { return (<FormArray>form.get(key)).controls; }

  /***********************************************Auto Complete********************************************/

  /**
 * Capitaliza una cadena de texto
 *
 * Convierte la cadena a minúsculas, la divide por espacios y pone en mayúscula
 * la primera letra de cada palabra.
 *
 * @val -> string a capitalizar
 * @return -> string con cada palabra capitalizada
 */

capitalize(val: any): string {
  if (!val && val !== 0) return ''; // Manejar null, undefined, empty string, pero mantener 0

  return String(val)
    .toLowerCase()
    .trim()
    .split(/\s+/) // Divide por uno o más espacios
    .filter(word => word.length > 0) // Filtra palabras vacías
    .map(word => {
      // Encontrar el primer carácter alfabético
      const firstLetterMatch = word.match(/[a-zñáéíóúü]/i);

      if (firstLetterMatch) {
        const firstLetterIndex = firstLetterMatch.index || 0;
        // Capitalizar la primera letra alfabética encontrada
        return word.substring(0, firstLetterIndex) +
               word[firstLetterIndex].toUpperCase() +
               word.substring(firstLetterIndex + 1);
      }

      // Si no hay letras, devolver la palabra tal cual
      return word;
    })
    .join(' ');
}
/**
 * Método para obtener todas las ubicaciones según el tipo.
 *
 * Este método asigna valores a las ubicaciones de origen y destino en el formulario, basándose en el tipo
 * (origen o destino) y los datos proporcionados. Además, establece valores y valida los campos en el formulario.
 *
 * @keyword -> objeto que contiene la información de la ubicación, como `destination_code`, `id`, `address`.
 * @type -> tipo de ubicación, que puede ser 'origin' o 'destination'.
 */
async getLocationsAll(selected: {data: any, type: string}, inputType: string) {
  const keyword = selected.data;
  const type = selected.type;
  if (keyword) {
    switch (inputType) {

      case 'origin':
          keyword.type = type;
          this.pickup = { id: keyword?.id ?? null, name: null, latitude: null, longitude: null};
          this._form.get('firstOrigin').setValue(keyword); // Asignamos el objeto completo
          this._form.get('firstOrigin').setErrors(null);
          this._form.get('firstOrigin').updateValueAndValidity();
          this.setCaretToEnd(this.originInput);
          this.countryPickupLocation = keyword?.country_code;
          switch(type) {
            case 'airport':
              this.selectediataCodeOrigin = keyword.iata;
              this.originInputValue = `${keyword.name}, ${keyword.country_code} (${keyword.iata})`;
              this.pickup['address']= keyword.iata.replace(/[()]/g, '');
              this.pickup['type']= 'airport';
              this.pickup['origin'] = keyword.city_iata;
              this.pickup['name'] = keyword.name;
              this.pickup['longitude'] = keyword.longitude;
              this.pickup['latitude'] = keyword.latitude;
              break;
            case 'city':
              this.originInputValue = keyword.display;

              try {
              // Convertir Observable a Promise usando lastValueFrom (RxJS 7+)

              const res = await this._restService.doGet('api', `/utilities/searchlocations?address=true&placeId=${keyword.place_id}`)
                    .toPromise();

              if(res.addressGoogle) {
                this.selectediataCodeOrigin = res.addressGoogle.iata;
                this.pickup['name'] = res.addressGoogle.name;
                this.pickup['longitude'] = res.addressGoogle.longitude;
                this.pickup['latitude'] = res.addressGoogle.latitude;
                this.pickup['address'] = res.addressGoogle.address;
                this.pickup['type'] = 'city';
                this.pickup['origin'] = res.addressGoogle.iata;
              }
            } catch (error: any) {
              console.error('Error fetching city data:', error);
              // Manejar el error
            }
            break;
            case 'hotel':
                this.selectediataCodeOrigin = keyword.address;
                this.originInputValue = `${keyword.name}, ${keyword.city_name}`;
                this.pickup['address'] = keyword.address.replace(/[()]/g, '');
                this.pickup['type']= 'hotel';
                this.pickup['origin'] = keyword.iata;
                this.pickup['name'] = keyword.name;
                this.pickup['longitude'] = keyword.longitude;
                this.pickup['latitude'] = keyword.latitude;
              break;
            case 'restaurant':
            case 'attraction':
                this.selectediataCodeOrigin = keyword.address;
                this.pickup['address'] = keyword.address.replace(/[()]/g, '');
                this.originInputValue =  `${keyword.name}, ${keyword.city_name}, ${keyword.country_name}`;
                this.pickup['type'] = type;
                this.pickup['longitude'] = keyword.longitude;
                this.pickup['latitude'] = keyword.latitude;
                this.pickup['origin'] = keyword.iata;
                this.pickup['name'] = keyword.name;
              break;
            case 'train':
            case 'bus':
            case 'port':
                this.selectediataCodeOrigin = keyword.iata;
                this.pickup['address'] = keyword.iata.replace(/[()]/g, '');
                this.originInputValue =  `${keyword.name}, ${keyword.city_name}, ${keyword.country_name}`;
                this.pickup['type'] = type;
                this.pickup['origin'] = keyword.iata;
                this.pickup['longitude'] = keyword.longitude;
                this.pickup['latitude'] = keyword.latitude;
                this.pickup['name'] = keyword.name;
              break;
          }

        if(keyword.id === this._form.get('firstDestination').value?.id &&
           this.pickup['type'] === this.dropoff?.['type'] &&
          this.pickup['name'] === this.dropoff?.['name'] &&
          this.pickup['longitude'] === this.dropoff?.['longitude'] &&
          this.pickup['latitude'] === this.dropoff?.['latitude']) {
          this.notificationService.info('El pickup no puede ser igual que el dropoff');
          this.resetInputsOriginDestination('origin');
          return;
        }

        break;
      case 'destination':
          keyword.type = type;
          this.dropoff = { id: keyword?.id ?? null, name: null, latitude: null, longitude: null};

          this._form.get('firstDestination').setValue(keyword); // Asignamos el objeto completo
          this._form.get('firstDestination').setErrors(null);
          this._form.get('firstDestination').updateValueAndValidity();
          this.setCaretToEnd(this.myInputField);
          this.countryDropoffLocation = keyword.country_code;

          switch(type) {
            case 'airport':
              this.selectediataCodeDestiny = keyword.iata;
              this.destinationInputValue = `${keyword.name}, ${keyword.country_code} (${keyword.iata})`;
              this.dropoff['address']= keyword.iata.replace(/[()]/g, '');
              this.dropoff['type']= 'airport';
              this.dropoff['destination'] = keyword.city_iata;
              this.dropoff['name'] = keyword.name;
              this.dropoff['longitude'] = keyword.longitude;
              this.dropoff['latitude'] = keyword.latitude;
              break;
            case 'city':
                this.destinationInputValue = keyword.display;

              try {
              // Convertir Observable a Promise usando lastValueFrom (RxJS 7+)

              const res = await this._restService.doGet('api', `/utilities/searchlocations?address=true&placeId=${keyword.place_id}`)
                    .toPromise();

              if(res.addressGoogle) {
                this.selectediataCodeDestiny = res.addressGoogle.iata;
                this.dropoff['name'] = res.addressGoogle.name;
                this.dropoff['longitude'] = res.addressGoogle.longitude;
                this.dropoff['latitude'] = res.addressGoogle.latitude;
                this.dropoff['address'] = res.addressGoogle.address;
                this.dropoff['type'] = 'city';
                this.dropoff['destination'] = res.addressGoogle.iata;
              }
            } catch (error: any) {
              console.error('Error fetching city data:', error);
              // Manejar el error
            }
              break;
            case 'hotel':
                this.selectediataCodeDestiny = keyword.address;
                this.destinationInputValue = `${keyword.name}, ${keyword.city_name}`;
                this.dropoff['address'] = keyword.address.replace(/[()]/g, '');
                this.dropoff['type']= 'hotel';
                this.dropoff['destination'] = keyword.iata;
                this.dropoff['name'] = keyword.name;
                this.dropoff['longitude'] = keyword.longitude;
                this.dropoff['latitude'] = keyword.latitude;
                this.dropoff['name'] = keyword.name;
              break;
            case 'restaurant':
            case 'attraction':
                this.selectediataCodeDestiny = keyword.address;
                this.dropoff['address'] = keyword.address.replace(/[()]/g, '');
                this.destinationInputValue =  `${keyword.name}, ${keyword.city_name}, ${keyword.country_name}`;
                this.dropoff['type'] = type;
                this.dropoff['destination'] = keyword.iata;
                this.dropoff['longitude'] = keyword.longitude;
                this.dropoff['latitude'] = keyword.latitude;
                this.dropoff['name'] = keyword.name;
              break;
            case 'train':
            case 'bus':
            case 'port':
                this.selectediataCodeDestiny = keyword.iata;
                this.dropoff['address'] = keyword.iata.replace(/[()]/g, '');
                this.destinationInputValue =  `${keyword.name}, ${keyword.city_name}, ${keyword.country_name}`;
                this.dropoff['type'] = type;
                this.dropoff['destination'] = keyword.iata;
                this.dropoff['longitude'] = keyword.longitude;
                this.dropoff['latitude'] = keyword.latitude;
                this.dropoff['name'] = keyword.name;
              break;
            }

        if(keyword.id === this._form.get('firstOrigin').value?.id &&
         this.dropoff['type'] === this.pickup?.['type'] &&
          this.dropoff['name'] === this.pickup?.['name'] &&
          this.dropoff['longitude'] === this.pickup?.['longitude'] &&
          this.dropoff['latitude'] === this.pickup?.['latitude']) {
          this.notificationService.info('El dropoff no puede ser igual que el pickup');
          this.resetInputsOriginDestination('destination');
          return;
        }

        break;
    }
  }

}

/**
 * Resetea los valores de origen o destino
 *
 * Este método se utiliza para limpiar los campos del formulario
 * relacionados con el origen o destino, dependiendo del tipo recibido.
 *
 * @type -> parámetro de tipo string que puede ser 'origin' o 'destination'
 *
 * 'origin':
 *  - Limpia `originInputValue`
 *  - Setea el campo 'firstOrigin' del formulario en null
 *  - Reinicia `pickup` y `selectediataCodeOrigin`
 *
 * 'destination':
 *  - Limpia `destinationInputValue`
 *  - Setea el campo 'firstDestination' del formulario en null
 *  - Reinicia `dropoff` y `selectediataCodeDestiny`
 *
 * @form -> formulario reactivo al que se le reinician campos específicos
 */
resetInputsOriginDestination(type: string) {
  switch(type) {
    case 'origin':
      this.originInputValue = undefined;
      this._form.get('firstOrigin').setValue(null);
      this.pickup = undefined;
      this.selectediataCodeOrigin = undefined;
      this.countryPickupLocation = undefined;

      break;
    case 'destination':
      this.destinationInputValue = undefined;
      this._form.get('firstDestination').setValue(null);
      this.dropoff = undefined;
      this.selectediataCodeDestiny = undefined;
      this.countryDropoffLocation = undefined;
      break;
    default:
      break;
  }
}
/**
 * Método para mostrar el nombre de una ubicación.
 *
 * Este método construye y devuelve una cadena con el nombre del hotel, la dirección, el código IATA, el código de destino
 * o el código de país de la ubicación. La información es extraída del objeto `name`.
 *
 * @name -> objeto que contiene la información de la ubicación, como `hotel_name`, `address`, `iata`, `destination_code`, `country_code`.
 * @returns -> una cadena con el nombre y la información adicional de la ubicación.
 */
displayFn(name): string {
  if(name) {

    if(name.type === 'hotel') {
      return name.hotel_name ? name.hotel_name : name.name;
    }
    if(name.type === 'city') {

      let value: string = '';

        if(name?.city_province) {
          value = `${name?.main_text || ''}, ${name?.city_province || ''}, ${name?.country_name || ''}`;
        } else {
          value = `${name?.main_text || ''}, ${name?.secondary_text || ''}`;
        }

      return value;
    }
    return `${name.hotel_name ? name.hotel_name : name.name} ${name.address ? "("+name.address+")": ''}${name.iata ? "("+name.iata+")": ''}${name.destination_code ? "("+name.destination_code+")": ''}${name.country_code ? "("+name.country_code+")": ''}`;

  } else {
    return '';
  }
}


getVariableCityOrigin(selected?: any): string {

  if(selected?.city_province) {
    return `${selected.main_text || ''}, ${selected.city_province || ''}, ${selected.country_name || ''}`;
  } else {
    return `${selected.main_text || ''}, ${selected.secondary_text || ''}`;
  }
}

/**
 * Método para actualizar el color del botón de confirmación.
 *
 * Este método cambia el color de fondo del botón de confirmación dependiendo de si el usuario está pasando el mouse sobre él
 * o no. El color de fondo se obtiene de la configuración global del cliente.
 */
updateButtonColorConfirm() {
  const button = document.querySelector('.btn-choice-confirm') as HTMLElement;
  if (this.isHoverConfirm) {
    button.style.backgroundColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
  } else {
    button.style.backgroundColor = 'white';
  }
}

  /***********************************************Auto Complete********************************************/

/**
 * Método para emitir un valor 'false' al modal.
 *
 * Este método se utiliza para cerrar o ocultar el modal, enviando un evento con el valor 'false'.
 */
_over() {
  this.modal.emit('false');
}

/**
 * Método para ejecutar una acción cuando se hace clic fuera de un área específica.
 *
 * Este método es llamado cuando el usuario hace clic fuera del área del modal o elemento específico.
 * Se utiliza para establecer o actualizar los pasajeros en el formulario.
 *
 * @event -> objeto que representa el evento del clic fuera.
 */
clickOutside(event: any) {
  this.setPassanger();
}

/**
 * Método para abrir el modal.
 *
 * Este método cambia el estado de la variable `isCollapsed` a `true`, y la variable `_close` a `false`.
 * Después de un pequeño retardo, emite un evento con el valor 'true' para abrir el modal.
 */
_openModal() {
  this.applyImageFilter();
  this.isCollapsed = true;
  this._close = false;
  this.closing = false;
  setTimeout(() => {
    this.modal.emit('true');
  }, 100);
}

/**
 * Método para confirmar la selección y cerrar el modal.
 *
 * Este método cambia el estado de `isCollapsed` a `false` y luego ejecuta la función `setPassanger`
 * para actualizar los datos de los pasajeros.
 */
_confirm() {
  this.isCollapsed = false;
  this.setPassanger();

    setTimeout(() => {
    this.closing = false;
  }, 100);
}

/**
 * Método para establecer los pasajeros en el formulario.
 *
 * Este método obtiene la cantidad de adultos y niños desde el formulario, y genera un string representando
 * la cantidad de pasajeros en el formato adecuado. Si no hay pasajeros seleccionados, se establece el texto "Pasajeros".
 */
setPassanger() {
  let adults = this._form.value['firstqtyAdults'];
  let childs = this._form.value['firstqtyChilds'];
  let noSelected = (parseInt(adults) === 0 && parseInt(childs) === 0);
  adults = adults != undefined ? adults + " Adultos " : null;
  childs = childs != undefined ? " - " + childs + " Niños " : null;

  this.passengers = noSelected ? "Pasajeros" : adults + childs;
}

/**
 * Método para intercambiar las ubicaciones de origen y destino.
 *
 * Este método intercambia los valores de origen y destino en el formulario. Los valores se toman de los campos
 * `firstOrigin` y `firstDestination` y luego se aplican en el formulario usando `patchValue`.
 */
swapLocations() {
  // Intercambiar valores del formulario
  const origin = this._form.get('firstOrigin')?.value;
  const destination = this._form.get('firstDestination')?.value;

  this._form.patchValue({
    firstOrigin: destination,
    firstDestination: origin
  });

  // Intercambiar pickup y dropoff
  const tempPickup = this.pickup;
  this.pickup = this.dropoff;
  this.dropoff = tempPickup;

  // Intercambiar códigos IATA
  const tempIata = this.selectediataCodeOrigin;
  this.selectediataCodeOrigin = this.selectediataCodeDestiny;
  this.selectediataCodeDestiny = tempIata;

  //seteamos los iata de cada destino.
  this.countryIataOrigin = this.pickup.destination;
  this.countryIataDestiny = this.dropoff.origin;

  // Intercambiar los valores visuales de los inputs
  const tempInputValue = this.originInputValue;
  this.originInputValue = this.destinationInputValue;
  this.destinationInputValue = tempInputValue;
}


/**
 * Método para manejar el cambio de fecha.
 *
 * Este método se utiliza para establecer la fecha de llegada en el formulario y la hora actual,
 * o para restablecer la fecha si el valor es `null`.
 *
 * @value -> valor de tipo Date que representa la nueva fecha de llegada seleccionada.
 */
onDateChange(value: Date | null) {
  if (value) {
    this.oneWay = false;
    this._form.get('secondArrivalDate').setValue(value);
  } else {
    this._form.get('secondArrivalDate').setValue(null);
    this._form.get('secondTime').setValue(null);
    this.oneWay = true;
  }
}

/**
 * Método para restablecer la fecha de llegada.
 *
 * Este método restablece el valor de `secondArrivalDate` y `secondTime` en el formulario a `null`.
 */
resetSecondArrivalDate(): void {
  this.oneWay = true;
  this._form.get('secondArrivalDate').setValue(null);
  this._form.get('secondTime').setValue(null);
  this._form.get('type').setValue('oneTrip');
}

/**
 * Abre el modal principal
 *
 * Este método establece la propiedad `showModal` en `true`
 * para mostrar el modal asociado.
 *
 * @showModal -> estado booleano que determina si el modal está activo
 */
fileActive() {
  this.showModal = true;
}

/**
 * Label del botón BUSCAR unificado.
 * Devuelve "BUSCAR NO ACTIVO" cuando no hay itinerario activo, "BUSCAR" en caso contrario.
 */
getSearchButtonLabel(): string {
  return 'BUSCAR';
}

/**
 * Handler unificado del botón BUSCAR.
 * Decide la acción según el estado del itinerario activo:
 *  - Sin itinerario activo → pide crear uno (fileActive).
 *  - Itinerario activo pero completado (status_id === 6) → avisa que hay que crear uno nuevo (filePaid).
 *  - Itinerario activo editable → submit del form si es válido.
 */
onSearchClick(): void {
  if (!this.userService.itineraryActive || this.userService.itineraryActive.length === 0) {
    this.fileActive();
    return;
  }

  if (this.validateButtonSearch) {
    this.filePaid();
    return;
  }

  this._form.markAllAsTouched();
  if (this._form.valid) {
    this._onSubmit(this._form);
  }
}

/**
 * Cierra el modal principal
 *
 * Este método cambia la propiedad `showModal` a `false`
 * para cerrar el modal que fue previamente abierto.
 *
 * @showModal -> se establece en falso para cerrar el modal
 */
closeModal() {
  this.showModal = false;
}

/**
 * Confirma la acción y cierra el modal
 *
 * Este método es un wrapper de `closeModal()`, usado cuando el usuario
 * confirma una acción dentro del modal.
 *
 * @uses closeModal -> cierra el modal actual
 */
confirmAction() {
  this.closeModal();
}

/**
 * Toggle the wheel time picker dropdown
 * @param pickerId - 'firstTime' or 'secondTime'
 * @param event - click event
 */
toggleTimePicker(pickerId: 'firstTime' | 'secondTime', event: Event): void {
  if (pickerId === 'secondTime') {
    if (!this._form.get('secondArrivalDate').value) return;
    if (!this._form.get('firstTime')?.value) return;
  }
  event.stopPropagation();
  this.activeTimePicker = this.activeTimePicker === pickerId ? null : pickerId;
}

/**
 * Format-as-you-type handler. Does NOT write to the form control here.
 * Just cleans the typed string and visually inserts a colon after 2 digits.
 * Mirrors the approach used in flight-modal so wheel + manual entry coexist.
 */
_onManualTimeInput(event: Event, controlName: 'firstTime' | 'secondTime'): void {
  const input = event.target as HTMLInputElement;
  const raw = input.value;

  const digits = raw.replace(/\D/g, '').slice(0, 4);

  let formatted = digits;
  if (digits.length >= 3) {
    formatted = `${digits.slice(0, 2)}:${digits.slice(2)}`;
  } else if (digits.length === 2 && raw.includes(':')) {
    formatted = `${digits}:`;
  }

  if (input.value !== formatted) {
    const cursorPos = input.selectionStart || 0;
    input.value = formatted;
    const newPos = Math.min(cursorPos + (formatted.length - raw.length), formatted.length);
    input.setSelectionRange(newPos, newPos);
  }
}

/**
 * Blur handler. Validates the entered time and writes the final value to the
 * form control. For 'secondTime' the input is only enabled when a return date
 * is set; for 'firstTime' it is always enabled.
 */
_onTimeInputBlur(controlName: 'firstTime' | 'secondTime', event: FocusEvent): void {
  const input = event.target as HTMLInputElement;
  const fc = this._form.get(controlName);
  const dateField = controlName === 'firstTime' ? 'firstArrivalDate' : 'secondArrivalDate';
  const dateValue = this._form.get(dateField)?.value;

  // For secondTime: refuse if firstTime is not set yet.
  if (controlName === 'secondTime' && !this._form.get('firstTime')?.value) {
    input.value = '';
    fc?.setValue(null);
    return;
  }

  const digits = input.value.replace(/\D/g, '');
  if (digits.length === 0) {
    const fallback = dateValue ? this.currentTime : null;
    fc?.setValue(fallback);
    input.value = fallback ?? '';
    return;
  }

  const padded = digits.padEnd(4, '0').slice(0, 4);
  const hours = parseInt(padded.slice(0, 2), 10);
  const minutes = parseInt(padded.slice(2, 4), 10);

  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
    const prev = this._previousTimeValues[controlName];
    const fallback = prev || (dateValue ? this.currentTime : null);
    fc?.setValue(fallback);
    input.value = fallback ?? '';
    return;
  }

  const formatted = `${padded.slice(0, 2)}:${padded.slice(2, 4)}`;

  // For secondTime: must be >= firstTime. (No currentTime check.)
  if (controlName === 'secondTime') {
    const floor = this.getSecondTimeFloor();
    if (floor && this.isTimeBefore(formatted, floor)) {
      fc?.setValue(floor);
      input.value = floor;
      this._previousTimeValues[controlName] = floor;
      return;
    }
  } else {
    // firstTime: enforce minimum (currentTime when the trip is scheduled for today).
    const minAllowed = this.getMinAllowedTime(controlName);
    if (minAllowed && this.isTimeBefore(formatted, minAllowed)) {
      fc?.setValue(this.currentTime);
      input.value = this.currentTime;
      this._previousTimeValues[controlName] = this.currentTime;
      return;
    }
  }

  fc?.setValue(formatted);
  input.value = formatted;
  this._previousTimeValues[controlName] = formatted;
}

/**
 * Close the wheel time picker dropdown
 */
closeTimePicker(): void {
  this.activeTimePicker = null;
}

/**
 * Handle clicks outside the time picker to close it
 */
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  if (this.activeTimePicker) {
    const target = event.target as HTMLElement;
    // Check if click was inside any wheel-picker-wrapper
    const pickerWrapper = target.closest('.wheel-picker-wrapper');
    if (!pickerWrapper) {
      this.activeTimePicker = null;
    }
  }
}

/**
 * Devuelve un mensaje según el tipo de ubicación
 *
 * Este método genera un mensaje personalizado dependiendo si
 * el origen o destino es un aeropuerto u hotel.
 *
 * @param input: string -> puede ser 'origin' o 'destination'
 * @pickup: objeto -> contiene información sobre el punto de origen
 * @dropoff: objeto -> contiene información sobre el punto de destino
 *
 * @returns string -> mensaje personalizado según el tipo
 * Ejemplo: "Hora arribo del vuelo" o "Hora pickup del hotel"
 */
  getMessageFirstTime(input: 'origin' | 'destination'): string {
          // Determinar si estamos procesando origen o destino
          const isOrigin = input === 'origin';

          // Obtener la ubicación correspondiente
          const primaryLocation = isOrigin ? this.pickup : this.dropoff;
          const fallbackLocation = isOrigin ? this.dropoff : this.pickup;

          // Determinar el tipo
          let type = primaryLocation?.type || fallbackLocation?.type || 'default';

          // Para otros tipos, obtener mensaje de la tabla
          const typeMessages = MESSAGE_LOOKUP[type];

          if (typeMessages) {

            if(isOrigin) {
              return this.messageTypeFlySelectedFirstTime ?
                     typeMessages.origin :
                     typeMessages.default;
            } else {
               return this.messageTypeFlySelectedSecondTime ?
                     typeMessages.origin :
                     typeMessages.default;
            }
          }

          // Valor por defecto
          return 'Hora del pickup';
        }

      close(): void {

    this.dialogRef.close(null);
  }

    filePaid():void{
    if(this.validateButtonSearch){
      this.titleModal = 'File Completado',
      this.messageModal = 'Este file se encuentra completado, por favor, crea un nuevo file para hacer una búsqueda'
      this.showModal = true;
    }
  }

getPickupType(type): boolean {

  if(!type) {
    return;
  }

  return type === 'airport' ||
         type === 'port' ||
         type === 'train' ||
         type === 'bus' ||
         type === 'restaurant' ||
         type === 'attraction'
}

  /**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}



incrementPassengerAdult(event?: Event) {

      if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const form = this._form;

    // Obtener valor actual
    const currentValue = form.get('firstqtyAdults')?.value || 0;

    // Validar máximo
    if (currentValue >= this.MAX_ADULTS) return;

    // Actualizar usando patchValue (método reactivo)
    form.patchValue({
        firstqtyAdults: currentValue + 1
    });
}

decrementPassengerAdult(event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const form = this._form;

    // Obtener valor actual
    const currentValue = form.get('firstqtyAdults')?.value || 0;

    // Validar mínimo (mínimo 1 adulto)
    if (currentValue <= 1) return;

    // Actualizar usando patchValue
    form.patchValue({
        firstqtyAdults: currentValue - 1
    });
}

incrementPassengerChildren(item: FormGroup, event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const form = this._form;

    // Obtener valor actual
    const currentValue = form.get('firstqtyChilds')?.value || 0;

    // Validar máximo
    if (currentValue >= 10) return;

    // Actualizar usando patchValue
    form.patchValue({
        firstqtyChilds: currentValue + 1
    });

    // Añadir control de edad para el nuevo niño
    const ages = form.get("firstchildsage") as FormArray;
    ages.push(this.fb.group({
        id: [currentValue],
        age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])]
    }));
}

decrementPassengerChildren(item: FormGroup, event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const form = this._form;

    // Obtener valor actual
    const currentValue = form.get('firstqtyChilds')?.value || 0;

    // Validar mínimo
    if (currentValue <= 0) return;

    // Actualizar usando patchValue
    form.patchValue({
        firstqtyChilds: currentValue - 1
    });

    // Eliminar control de edad del último niño
    const ages = form.get("firstchildsage") as FormArray;
    if (ages.length > 0) {
        ages.removeAt(ages.length - 1);
    }
}

getPassengerCountAdult(): number {

    return this._form.get('firstqtyAdults')?.value || 0;
}

getPassengerCountChildren(): number {
    return this._form.get('firstqtyChilds')?.value || 0;
}

  validatePassengerInput(event: any) {

        if (event) {
          event.stopPropagation(); // Evita que el clic se propague
          event.preventDefault();  // Previene comportamiento por defecto
      }

      const inputValue = parseInt(event.target.value, 10);
      const form = this._form;

      // Determinar si es adulto o niño (podrías pasar un parámetro)
      const isAdult = event.target.name === 'adults'; // Asigna nombres a los inputs

      if (isAdult) {
          // Validar adultos (1-MAX_ADULTS)
          const validatedValue = Math.max(1, Math.min(this.MAX_ADULTS, isNaN(inputValue) ? 1 : inputValue));
          form.patchValue({ qtyAdults: validatedValue });
      } else {
          // Validar niños (0-10)
          const validatedValue = Math.max(0, Math.min(10, isNaN(inputValue) ? 0 : inputValue));
          form.patchValue({ qtyChilds: validatedValue });

          // Ajustar array de edades
          this.adjustChildrenAges(validatedValue);
      }
  }

private adjustChildrenAges( newChildCount: number): void {
    const form = this._form;
    const ages = form.get("firstchildsage") as FormArray;
    const currentCount = ages.length;

    if (newChildCount > currentCount) {
        // Agregar edades faltantes
        for (let i = currentCount; i < newChildCount; i++) {
            ages.push(this.fb.group({
                id: [i],
                age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])]
            }));
        }
    } else if (newChildCount < currentCount) {
        // Eliminar edades excedentes
        while (ages.length > newChildCount) {
            ages.removeAt(ages.length - 1);
        }
    }
}

// Agrega estos métodos a tu componente

handleAdultInput(event: any): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    // Prevenir entrada de 0 como primer dígito
    if (event.key === '0' && event.target.value === '') {
        event.preventDefault();
        return;
    }

    // Solo permitir números
    if (!/^\d$/.test(event.key) &&
        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        return;
    }
}
    // firstqtyAdults: [1, [Validators.required, Validators.min(1)]],
    // firstqtyChilds: [0, Validators.required],
    // firstchildsage: this.fb.array([]),
handleAdultBlur(event: any): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const value = event.target.value.trim();
    const form = this._form;

    if (value === '' || value === '0' || isNaN(parseInt(value, 10))) {
        form.patchValue({ firstqtyAdults: 1 });
        event.target.value = '1';
    }

    if(value !== '' && parseInt(value, 10) > this.MAX_ADULTS) {
      const numericValue = parseInt(value, 10);
      event.target.value = numericValue.toString();

      form.patchValue({ firstqtyAdults: 1 });
      event.target.value = '10';
    }

}


handleChildrenInput(event: any): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const currentValue = event.target.value;

    // Si está vacío y se presiona 0, prevenir
    if (event.key === '0' && currentValue === '') {
        event.preventDefault();
        return;
    }

    // Solo permitir números
    if (!/^\d$/.test(event.key) &&
        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        return;
    }

    // Prevenir que escriba más de 2 dígitos (para edades hasta 17)
    if (/^\d$/.test(event.key) && currentValue.length >= 2) {
        event.preventDefault();
        return;
    }
}

handleChildrenBlur(event: any): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const value = event.target.value.trim();

    // Si está vacío, poner 0
    if (value === '' || isNaN(parseInt(value, 10))) {
        const form = this._form;
        form.patchValue({ firstqtyAdults: 0 });
        event.target.value = '0';
        this.adjustChildrenAges(0);
    } else {
        // Si tiene un valor válido, asegurarse de que no tenga ceros a la izquierda
        const numericValue = parseInt(value, 10);
        event.target.value = numericValue.toString();

         const form = this._form;
        form.patchValue({ firstqtyAdults: numericValue });
        this.adjustChildrenAges(numericValue);
    }
}

preventModalClose(event: MouseEvent): void {
    // Detiene la propagación del evento click para que no llegue al listener
    // que cierra el modal
    event.stopPropagation();
    event.preventDefault();

    // Opcional: Forzar el foco en el input
    const target = event.target as HTMLInputElement;
    target.focus();
}

agesChildsArr(): string[] {
    return Array.from({length: 18}, (_, index) => {
        return index.toString();
    });
}


/**
 * Expande y posiciona estratégicamente el contenedor de configuración de pasajeros
 *
 * Este método ajusta el posicionamiento del contenedor de configuración de pasajeros
 * para que aparezca fijo en relación al elemento contenedor, con ajustes automáticos
 * para evitar que se salga de los límites del viewport.
 *
 * @returns {void}
 *
 * @prerequisites
 * - Solo ejecuta si `this.componentResults` es true
 * - Requiere que existan los elementos DOM correspondientes
 *
 * @process
 * 1. Localiza elementos DOM del contenedor y configuración
 * 2. Calcula posición basada en el contenedor padre
 * 3. Aplica estilos de posicionamiento fixed preciso
 * 4. Realiza ajustes de boundaries con `adjustElementPosition`
 *
 * @positioning
 * - Posición: fixed (respecto al viewport)
 * - Top: bottom del contenedor + scroll vertical
 * - Left: left del contenedor + scroll horizontal
 * - Z-index: 9999 (máxima prioridad visual)
 *
 * @elements
 * - .config-passenger: Elemento a posicionar
 * - .element-config-passenger: Elemento de referencia para posicionamiento
 *
 * @uses adjustElementPosition() - Para ajustes de boundaries del viewport
 */
expandedConfigPassenger(): void {

  if(this.componentResults) {
    const configPassengerElement = document.querySelector('.config-passenger') as HTMLElement;
    const configPassengerContainer = document.querySelector('.element-config-passenger') as HTMLElement;
    if(configPassengerElement && configPassengerContainer) {

      // Calculamos la posición del input en el viewport
        const inputRect = configPassengerContainer.getBoundingClientRect();

       // Ajustamos la posición del picker relativa al input
        configPassengerElement.style.position = 'fixed';


        // configPassengerElement.style.top = `${inputRect.bottom + window.scrollY}px`;
        // configPassengerElement.style.left = `${inputRect.left + window.scrollX}px`;
        configPassengerElement.style.transform = 'none';
        configPassengerElement.style.maxHeight = 'none';
        configPassengerElement.style.overflow = 'visible';
        configPassengerElement.style.zIndex = '9999';

        configPassengerContainer.getBoundingClientRect();

          // Verificamos si el picker se sale de la pantalla y ajustamos
        // this.adjustElementPosition(configPassengerElement, inputRect);
    }

  }

}

  // ============================================
  // MÉTODOS DE PERSONALIZACIÓN DE UI
  // ============================================

  /**
   * Aplica filtro de color a los iconos basado en configuración del cliente
   * Convierte el color principal del cliente a filtro CSS
   */
  applyImageFilter() {
    const color = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;

    if (!color) {
      console.warn('No color defined');
      return;
    }

    try {
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";
      const filter = colorFilter;

      this.iconInfo.nativeElement.style.filter = filter;


    } catch (error) {
      console.error('Error applying image filter:', error);
    }
  }

  changeTypeSearch(event: any, type :string): void {

    if(event) {
      if(type === 'destination'){
        this.pointMessageDestination = 'Domicilio';

      } else {
        this.pointMessageOrigin = 'Domicilio';

      }


      this.generateSearchLocation(true, type);
    } else {
        if(type === 'destination'){
        this.pointMessageDestination = 'Traslado';

      } else {
        this.pointMessageOrigin = 'Traslado';

      }


      this.generateSearchLocation(false, type);
    }

    localStorage.setItem('transports-switch-state', JSON.stringify({
      origin: this.pointMessageOrigin,
      destination: this.pointMessageDestination
    }));

    this.updateSliderDestinationCircleColor();
    this.updateSliderCircleColor();
  }

  generateSearchLocation(pointToPoint: boolean, type: string): void {
  if(type === 'origin') {
    this.originSearchSub?.unsubscribe();
    this.originSearchSub = this._form.get('firstOrigin')?.valueChanges.subscribe((selectedValue) => {

      if(selectedValue === '' && this._form.get('firstDestination')?.value === '') {
        this.countryDropoffLocation = '';
      }

      this.destinationOptions = this._addressService.getLocationsAll(
        selectedValue,
        this.countryDropoffLocation,
        pointToPoint,
        'TRANSFERS'
      );
    });
  }


  if(type === 'destination') {
    this.destinationSearchSub?.unsubscribe();
    this.destinationSearchSub = this._form.get('firstDestination')?.valueChanges.subscribe((selectedValue) => {

      if(selectedValue === '' && this._form.get('firstOrigin')?.value === '') {
        this.countryPickupLocation = '';
      }

      this.destinationOptions_ = this._addressService.getLocationsAll(
        selectedValue,
        this.countryPickupLocation,
        pointToPoint,
        'TRANSFERS'
      );
    });
  }

}

rideHailingChange(event: any): void {

  const controls = this._form;

  if(event) {
    controls.get('firstArrivalDate')?.setValue(null);
  }
}

typeSearch(type: string): void {


  if(type === 'default') {
    this._form.get('rideHailing')?.setValue(false);

    this._form.get('firstArrivalDate')?.enable();
    this._form.get('firstTime')?.enable();
    this._form.get('secondArrivalDate')?.enable();
    this._form.get('secondTime')?.enable();

  } else {
    this._form.get('rideHailing')?.setValue(true);

    this._form.get('firstArrivalDate')?.disable();
    this._form.get('firstTime')?.disable();
    this._form.get('secondArrivalDate')?.disable();
    this._form.get('secondTime')?.disable();

    this._form.get('firstArrivalDate')?.setValue(this.now);
    this._form.get('firstTime')?.setValue(this.currentTime);
    this._form.get('secondArrivalDate')?.setValue(null);
    this._form.get('secondTime')?.setValue(null);

  }
}

getStyleBackgroundReturn(): string {

  if(!this._form.get('rideHailing')?.value) {
    return 'white';
  } else {
    return '#effef9';
  }

}

get sliderBackgroundColor(): string {
  return this.pointMessageOrigin === 'Traslado' ? 'white' : this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
}

get sliderDestinationBackgroundColor(): string {
  return this.pointMessageDestination === 'Traslado' ? 'white' : this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
}

get circleBackgroundColor(): string {
  return this.pointMessageOrigin === 'Traslado' ? this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : 'white';
}

private setCaretToEnd(inputRef: ElementRef | undefined): void {
  setTimeout(() => {
    const el = inputRef?.nativeElement;
    if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')) return;
    el.focus();
    const len = el.value?.length ?? 0;
    if (typeof el.setSelectionRange === 'function') {
      el.setSelectionRange(len, len);
    }
    // After programmatic value set, ensure the textarea height fits the content.
    this.autoGrow(el);
  }, 0);
}

// Resize a textarea to fit its wrapped content. Called on (input) and after
// programmatic value changes. Keeps a 49px minimum (original input height).
autoGrow(textarea: HTMLTextAreaElement | HTMLInputElement): void {
  if (!textarea || textarea.tagName !== 'TEXTAREA') return;
  // Reset to auto first so scrollHeight reflects the natural content size.
  textarea.style.height = 'auto';
  textarea.style.height = Math.max(49, textarea.scrollHeight) + 'px';
}

// Returns the user-visible text in the origin input (or empty string).
// Used to drive a hover tooltip so long names can be read in full.
get originTooltip(): string {
  const displayed = this.displayFn(this._form?.get('firstOrigin')?.value);
  return displayed && displayed.length > 30 ? displayed : '';
}

// Returns the user-visible text in the destination input (or empty string).
// Used to drive a hover tooltip so long names can be read in full.
get destinationTooltip(): string {
  const displayed = this.displayFn(this._form?.get('firstDestination')?.value);
  return displayed && displayed.length > 30 ? displayed : '';
}

getDistanceAirport(airport: any, type: string): string {
  let distance = '';

  if (airport?.city_distance) {
    const firstOrigin = this._form.get('firstOrigin')?.value;
    const firstDestination = this._form.get('firstDestination')?.value;

    let city: string = type === 'origin' ? firstOrigin : firstDestination;

    if (city) {
      // ✅ Transformar a mayúscula la primera letra de cada palabra
      city = this.capitalizeWords(city);

      switch (type) {
        case 'origin':
          distance = `Distancia de ${city}: ${airport?.city_distance}`;
          break;
        case 'destination':
          distance = `Distancia de ${city}: ${airport?.city_distance}`;
          break;
      }
    }
  }

  return distance;
}

/**
 * ✅ Capitaliza la primera letra de cada palabra
 * @param text - Texto a transformar
 * @param excludeWords - Palabras que NO deben capitalizarse (opcional)
 * @returns Texto con palabras capitalizadas
 */
private capitalizeWords(text: string, excludeWords: string[] = ['de', 'la', 'el', 'los', 'las', 'y', 'o', 'en', 'por', 'para']): string {
  if (!text) {
              return '';
              }

  return text
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      // ✅ Primera palabra siempre en mayúscula
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      // ✅ Palabras excluidas en minúscula
      if (excludeWords.includes(word)) {
        return word;
      }
      // ✅ Resto de palabras en mayúscula
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

}
